import gql from "graphql-tag"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

import homepageLaneQuery from "../../fragments/homepageLaneQuery"

export const query = gql`
  query Homepage($id: ID!) {
    homepage(id: $id) {
      uuid
      name
      description
      bannerTagId
      topCategoriesId
      state
      kind
      lanes {
        linkedEntityUrl
        type
        headerText
        bodyText
        image
        query {
          ...homepageLaneQuery
        }
        fallbackQuery {
          ...homepageLaneQuery
        }
      }
    }
  }
  ${homepageLaneQuery}
`

export const homepageByIdNoDealsKey = getQueryNames(query)[0]

export default query
